import { render, staticRenderFns } from "./ModalFooter.vue?vue&type=template&id=4b28ea43&scoped=true"
import script from "./ModalFooter.vue?vue&type=script&lang=js"
export * from "./ModalFooter.vue?vue&type=script&lang=js"
import style0 from "./ModalFooter.vue?vue&type=style&index=0&id=4b28ea43&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b28ea43",
  null
  
)

export default component.exports